import angular from 'angular';
import 'angular-permission';
import 'satellizer';
import 'restangular';
import Resources from '../resources/resources';
import Services from '../services/services';

export default angular.module('app.configs.permission', [
  Resources.name,
  Services.name,
  'permission',
  'satellizer',
  'restangular'
])
  .run(function(Permission, $auth, $q, $state, currentUser){
    let userHasRole = (role) => {
      let deferred = $q.defer();

      if (!$auth.isAuthenticated()) {
        deferred.reject();
        return deferred.promise;
      }

      let checkUserHasRole = ((user) => {
        if (user.hasRole(role)) {
          deferred.resolve();
        } else {
          deferred.reject();
        }
      });

      currentUser.subscribe(user => user ? checkUserHasRole(user) : null);

      return deferred.promise;
    };

    Permission
      .defineRole('anonymous', () => {
        return !$auth.isAuthenticated();
      })
      .defineRole('ADMIN', () => {
        return userHasRole('ADMIN');
      })
      .defineRole('GG_ACCOUNT_MANAGER', () => {
        return userHasRole('GG_ACCOUNT_MANAGER');
      })
      .defineRole('APP_DEVELOPER', () => {
        return userHasRole('APP_DEVELOPER');
      })
      .defineRole('GD_ACCOUNT_MANAGER', () => {
        return userHasRole('GD_ACCOUNT_MANAGER');
      })
      .defineRole('AGENCY', () => {
        return userHasRole('AGENCY');
      })
      .defineRole('ADMIN_AGENCY', () => {
        return userHasRole('ADMIN_AGENCY');
      })
      .defineRole('SELLER_ONLY', () => {
        return userHasRole('SELLER_ONLY');
      })
      .defineRole('BUYER_ONLY', () => {
        return userHasRole('BUYER_ONLY');
      })
      .defineRole('OPERATION_MANAGER', () => {
        return userHasRole('OPERATION_MANAGER');
      });
  })



/** WEBPACK FOOTER **
 ** ./src/configs/permission.config.js
 **/